// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2nDUv","consentsList":"PatientConsents_consentsList__-D_bp","consentsListEmpty":"PatientConsents_consentsListEmpty__2Bilw"};